export const base64ToBytes = (base64: string) => Uint8Array.from(atob(base64), character => character.charCodeAt(0));
